"use client"

import { getFeaturedBlockchain } from "@/app/blockchains/featured-blockchain/get-featured-blockchain"
import { useSelectedOrFeaturedBlockchain } from "@/app/blockchains/filters/use-blockchain-sync"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import { reatomComponent } from "@reatom/react"
import { ScopeProvider } from "bunshi/react"
import type { PropsWithChildren } from "react"
import { BalanceBlockchainScope } from "./balance-molecule"

export const BalanceBlockchainScopeProvider = reatomComponent<
  PropsWithChildren<{ blockchain?: Blockchain }>
>(({ children, blockchain }) => {
  const { selectedBlockchain } = useSelectedOrFeaturedBlockchain()

  const blockchainToUse = blockchain ?? selectedBlockchain

  return (
    <ScopeProvider scope={BalanceBlockchainScope} value={blockchainToUse}>
      {children}
    </ScopeProvider>
  )
}, "BalanceBlockchainScopeProvider")
